export const menu_items = {
  data: function(){
    return {
      menu_items: [
        {
          title: "file",
          sub_items: [
            {
              type: "item",
              name: "save_all"
            },
            {
              type: "item",
              name: "property"
            },
            {
              type: "item",
              name: "close"
            }
          ]
        },
        {
          title: "edit",
          sub_items: [
            {
              type: "item",
              name: "undo",
            },
            {
              type: "item",
              name: "redo",
            },
            {
              type: "divider",
            },
            {
              type: "item",
              name: "edit_text",
              sub_sub_items: [
                {
                  type: "item",
                  name: "cut_text",
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "item",
                  name: "copy_text",
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "item",
                  name: "paste_text",
                  context_menu: (index, column) => {
                    if(navigator.userAgent.toLowerCase().indexOf("firefox") >= 0){
                      // Firefoxは表示しない。
                      return false;
                    }
                    return true;
                  },
                  visible: (indexes, column) => {
                    if(navigator.userAgent.toLowerCase().indexOf("firefox") >= 0){
                      // Firefoxは表示しない。
                      return false;
                    }
                    return true;
                  }
                },
                {
                  type: "divider",
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "item",
                  name: "select_all",
                  context_menu: (index, column) => { return true; },
                }
              ]
            },
            {
              type: "divider",
            },
            {
              type: "item",
              name: "search",
              sub_sub_items: [
                {
                  type: "item",
                  name: "search_box",
                },
                {
                  type: "divider",
                },
                {
                  type: "item",
                  name: "search_next",
                },
                {
                  type: "item",
                  name: "search_prev",
                },
                {
                  type: "divider",
                },
                {
                  type: "item",
                  name: "replace_next",
                },
                /*
                {
                  type: "item",
                  name: "replace_prev",
                },
                */
                {
                  type: "item",
                  name: "replace_all"
                }
              ]
            }
          ]
        },
        {
          title: "sentence",
          sub_items: [
            {
              type: "item",
              name: "copy",
              sub_sub_items: [
                {
                  type: "divider",
                  visible: (indexes, column) => { return false; },
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "item",
                  name: "copy_source_to_target",
                  context_menu: (index, column) => {
                    return column === "target"
                      && this.store_getters_tab("content_mode") !== "source";
                  },
                },
                {
                  type: "divider",
                },
                {
                  type: "item",
                  name: "copy_target_to_source",
                  context_menu: (index, column) => {
                    return column === "source"
                      && this.store_getters_tab("content_mode") !== "source";
                  },
                }
              ]
            },
            {
              type: "item",
              name: "clear",
              sub_sub_items: [
                {
                  type: "divider",
                  visible: (indexes, column) => { return false; },
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "item",
                  name: "clear_source",
                  context_menu: (index, column) => {
                    return column === "source";
                  },
                },
                {
                  type: "item",
                  name: "reset_source",
                  context_menu: (index, column) => {
                    return column === "source";
                  },
                },
                {
                  type: "divider",
                },
                {
                  type: "item",
                  name: "clear_target",
                  visible: (indexes, column) => {
                    return this.store_getters_tab("content_mode") !== "source";
                  },
                  context_menu: (index, column) => {
                    return column === "target"
                      && this.store_getters_tab("content_mode") !== "source";
                  },
                },
                {
                  type: "item",
                  name: "reset_target",
                  visible: (indexes, column) => {
                    return this.store_getters_tab("content_mode") !== "source";
                  },
                  context_menu: (index, column) => {
                    return column === "target"
                      && this.store_getters_tab("content_mode") !== "source";
                  },
                },
                {
                  type: "divider",
                },
                {
                  type: "item",
                  name: "clear_memo",
                  context_menu: (index, column) => {
                    return column === "memo";
                  },
                },
                {
                  type: "item",
                  name: "reset_memo",
                  context_menu: (index, column) => {
                    return column === "memo";
                  },
                },
              ]
            },
            {
              type: "divider"
            },
            {
              type: "item",
              name: "split",
              sub_sub_items: [
                {
                  type: "divider",
                  visible: (indexes, column) => { return false; },
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "item",
                  name: "insert_sentence_above",
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "item",
                  name: "insert_sentence_below",
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "item",
                  name: "duplicate_sentence",
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "item",
                  name: "split_sentence",
                  context_menu: (index, column) => { return true; },
                }
              ]
            },
            {
              type: "item",
              name: "merge",
              sub_sub_items: [
                {
                  type: "divider",
                  visible: (indexes, column) => { return false; },
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "item",
                  name: "merge_sentence_above",
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "item",
                  name: "merge_sentence_below",
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "divider",
                  context_menu: (index, column) => { return false; },
                },
                {
                  type: "item",
                  name: "delete_sentence",
                  context_menu: (index, column) => { return true; },
                },
                {
                  type: "item",
                  name: "undelete_sentence",
                  context_menu: (index, column) => { return true; },
                }
              ]
            },
            {
              type: "divider",
              visible: (indexes, column) => { return false; },
              context_menu: (index, column) => { return true; },
            },
            {
              type: "item",
              name: "lock",
              context_menu: (index, column) => {
                if(index === null
                  || index < 0
                  || index >= this.store_getters_tab("content").length){
                  return false;
                }
                return this.store_getters_tab("content")[index].data.status.startsWith("editing");
              }
            },
            {
              type: "item",
              name: "unlock",
              context_menu: (index, column) => {
                if(index === null
                  || index < 0
                  || index >= this.store_getters_tab("content").length){
                  return false;
                }
                return this.store_getters_tab("content")[index].data.status === "locked";
              }
            }
          ]
        },
        {
          title: "display",
          sub_items: [
            {
              type: "item",
              name: "zoom_in",
            },
            {
              type: "item",
              name: "zoom_out",
            },
            {
              type: "divider",
            },
            {
              type: "item",
              name: "display_mode",
              sub_sub_items: [
                {
                  type: "item",
                  name: "layout_mode",
                },
                {
                  type: "item",
                  name: "menu_mode",
                },
                {
                  type: "item",
                  name: "sentence_mode",
                },
                {
                  type: "item",
                  name: "memo_mode",
                }
              ]
            }
          ]
        }
      ],
      menu_details: {
        // file
        save_all: {
          icon: "mdi-content-save",
          disabled: (indexes, column) => {
            var modified_tabs = [];
            var saving_tabs = [];
            for(var tab of this.$store.getters["editor/tabs"]){
              if(this.$store.getters["editor/" + tab.id + "/content_modified"]){
                modified_tabs.push(tab);
              }
              if(this.$store.getters["editor/" + tab.id + "/saving"]){
                saving_tabs.push(tab);
              }
            }
            return modified_tabs.length === 0
              || saving_tabs.length > 0;
          },
          action: (emit) => { emit({ command: "save_all" }) },
          restore_pos: "none"
        },
        property: {
          icon: "mdi-information",
          disabled: (indexes, column) => { return false; },
          action: (emit) => { emit({ command: "property" }) },
          restore_pos: "none"
        },
        close: {
          icon: "mdi-close-box",
          disabled: (indexes, column) => { return false; },
          action: (emit) => { emit({ command: "close" }) },
          restore_pos: "none"
        },
        // edit
        undo: {
          icon: "mdi-undo-variant",
          disabled: (indexes, column) => {
            return !this.store_getters_tab("history")
              || this.store_getters_tab("history").length === 0
              || this.store_getters_tab("history_index") >= this.store_getters_tab("history").length;
          },
          action: (emit) => {
            emit({
              command: "undo",
              param: {
                history_index: this.store_getters_tab("history_index")
              }
            });
          },
          restore_pos: null
        },
        redo: {
          icon: "mdi-redo-variant",
          disabled: (indexes, column) => {
            return !this.store_getters_tab("history")
              || this.store_getters_tab("history_index") === 0;
          },
          action: (emit) => {
            emit({
              command: "redo",
              param: {
                history_index: this.store_getters_tab("history_index")
              }
            });
          },
          restore_pos: null
        },
        edit_text: {
          icon: "mdi-file-edit",
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && this.store_getters_tab("content")
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")){
              return false;
            }else{
              return true;
            }
          },
          action: null,
          restore_pos: null
        },
        cut_text: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")){
              return this.$store.getters["editor/select_text"] === "";
            }else{
              return true;
            }
          },
          action: (emit) => { emit({ command: "cut_text" }) },
          restore_pos: null
        },
        copy_text:　{
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")){
              return this.$store.getters["editor/select_text"] === "";
            }else{
              return true;
            }
          },
          action: (emit) => { emit({ command: "copy_text" }) },
          restore_pos: null
        },
        paste_text:　{
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")){
              return false;
            }else{
              return true;
            }
          },
          action: (emit) => { emit({ command: "paste_text" }) },
          restore_pos: null
        },
        select_all:　{
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")){
              return false;
            }else{
              return true;
            }
          },
          action: (emit) => { emit({ command: "select_all" }) },
          restore_pos: null
        },
        search: {
          icon: "mdi-magnify",
          disabled: (indexes, column) => { return false; },
          action: null,
        },
        search_box: {
          disabled: (indexes, column) => { return false; },
          action: (emit) => { emit({ command: "search" }) },
          restore_pos: "none"
        },
        search_next: {
          disabled: (indexes, column) => {
            return this.$store.getters["editor/search_string"] === ""
              || this.$store.getters["editor/search_string"] === null;
          },
          action: (emit) => { emit({ command: "search_next" }) },
          restore_pos: null
        },
        search_prev:
        {
          disabled: (indexes, column) => {
            return this.$store.getters["editor/search_string"] === ""
              || this.$store.getters["editor/search_string"] === null;
          },
          action: (emit) => { emit({ command: "search_prev" }) },
          restore_pos: null
        },
        replace_next: {
          disabled: (indexes, column) => {
            return this.$store.getters["editor/search_string"] === ""
              || this.$store.getters["editor/search_string"] === null;
          },
          action: (emit) => {
            var replace_string = this.$store.getters["editor/replace_string"];
            emit({
              command: "replace_next",
              param: {
                replace_string: replace_string ? replace_string : ''
              }
            });
          },
          restore_pos: null
        },
        replace_prev:
        {
          disabled: (indexes, column) => {
            return this.$store.getters["editor/search_string"] === ""
              || this.$store.getters["editor/search_string"] === null;
          },
          action: (emit) => {
            var replace_string = this.$store.getters["editor/replace_string"];
            emit({
              command: "replace_prev",
              param: {
                replace_string: replace_string ? replace_string : ''
              }
            });
          },
          restore_pos: null
        },
        replace_all: {
          disabled: (indexes, column) => {
            return this.$store.getters["editor/search_string"] === ""
              || this.$store.getters["editor/search_string"] === null;
          },
          action: (emit) => {
            var replace_string = this.$store.getters["editor/replace_string"];
            emit({
              command: "replace_all",
              param: {
                replace_string: replace_string ? replace_string : ''
              }
            });
          },
          restore_pos: null
        },
        // sentence
        copy: {
          icon: "mdi-swap-horizontal",
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length > 0){
              // 選択あり
              for(var index of indexes){
                if(index >= 0
                  && index < this.store_getters_tab("content").length
                  && this.store_getters_tab("content")[index].data.status.startsWith("editing")){
                  return this.store_getters_tab("content_mode") === "source";
                }
              }
              return true;
            }else{
              // 選択なし
              return true;
            }
          },
          action: null
        },
        copy_source_to_target: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length > 0){
              // 選択あり
              for(var index of indexes){
                if(index >= 0
                  && index < this.store_getters_tab("content").length
                  && this.store_getters_tab("content")[index].data.status.startsWith("editing")){
                  return false;
                }
              }
              return true;
            }else{
              // 選択なし
              return true;
            }
          },
          action: (emit) => {
            emit({
              command: "copy",
              param: {
                from: "source",
                to: "target"
              }
            });
          },
          restore_pos: "head"
        },
        copy_target_to_source: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length > 0){
              // 選択あり
              for(var index of indexes){
                if(index >= 0
                  && index < this.store_getters_tab("content").length
                  && this.store_getters_tab("content")[index].data.status.startsWith("editing")){
                  return false;
                }
              }
              return true;
            }else{
              // 選択なし
              return true;
            }
          },
          action: (emit) => {
            emit({
              command: "copy",
              param: {
                from: "target",
                to: "source"
              }
            });
          },
          restore_pos: "head"
        },
        clear: {
          icon: "mdi-eraser",
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length > 0){
              // 選択あり
              for(var index of indexes){
                if(index >= 0
                  && index < this.store_getters_tab("content").length
                  && this.store_getters_tab("content")[index].data.status.startsWith("editing")){
                  return false;
                }
              }
              return true;
            }else{
              // 選択なし
              return true;
            }
          },
          action: null,
        },
        clear_source: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length > 0){
              // 選択あり
              for(var index of indexes){
                if(index >= 0
                  && index < this.store_getters_tab("content").length
                  && this.store_getters_tab("content")[index].data.status.startsWith("editing")){
                  var content = this.store_getters_tab("content")[index].data.source;
                  if(content.sentence !== ""
                    && content.sentence !== null){
                    return false;
                  }
                }
              }
              return true;
            }else{
              // 選択なし
              return true;
            }
          },
          action: (emit) => {
            emit({
              command: "clear",
              param: {
                column: "source"
              }
            });
          },
          restore_pos: "head"
        },
        reset_source: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length > 0){
              // 選択あり
              for(var index of indexes){
                if(index >= 0
                  && index < this.store_getters_tab("content").length
                  && this.store_getters_tab("content")[index].data.status.startsWith("editing")){
                  var content = this.store_getters_tab("content")[index].data.source;
                  if(content.sentence !== content.original
                    && content.original !== null){
                    return false;
                  }
                }
              }
              return true;
            }else{
              // 選択なし
              return true;
            }
          },
          action: (emit) => {
            emit({
              command: "reset",
              param: {
                column: "source"
              }
            });
          },
          restore_pos: "head"
        },
        clear_target: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length > 0){
              // 選択あり
              for(var index of indexes){
                if(index >= 0
                  && index < this.store_getters_tab("content").length
                  && this.store_getters_tab("content")[index].data.status.startsWith("editing")){
                  var content = this.store_getters_tab("content")[index].data.target;
                  if(content.sentence !== ""
                    && content.sentence !== null){
                    return false;
                  }
                }
              }
              return true;
            }else{
              // 選択なし
              return true;
            }
          },
          action: (emit) => {
            emit({
              command: "clear",
              param: {
                column: "target"
              }
            });
          },
          restore_pos: "head"
        },
        reset_target: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length > 0){
              // 選択あり
              for(var index of indexes){
                if(index >= 0
                  && index < this.store_getters_tab("content").length
                  && this.store_getters_tab("content")[index].data.status.startsWith("editing")){
                  var content = this.store_getters_tab("content")[index].data.target;
                  if(content.sentence !== content.original
                    && content.original !== null){
                    return false;
                  }
                }
              }
              return true;
            }else{
              // 選択なし
              return true;
            }
          },
          action: (emit) => {
            emit({
              command: "reset",
              param: {
                column: "target"
              }
            });
          },
          restore_pos: "head"
        },
        clear_memo: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length > 0){
              // 選択あり
              for(var index of indexes){
                if(index >= 0
                  && index < this.store_getters_tab("content").length
                  && this.store_getters_tab("content")[index].data.status.startsWith("editing")){
                  var content = this.store_getters_tab("content")[index].data.memo;
                  if(content.sentence !== ""
                    && content.sentence !== null){
                    return false;
                  }
                }
              }
              return true;
            }else{
              // 選択なし
              return true;
            }
          },
          action: (emit) => {
            emit({
              command: "clear",
              param: {
                column: "memo"
              }
            });
          },
          restore_pos: "head"
        },
        reset_memo: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length > 0){
              // 選択あり
              for(var index of indexes){
                if(index >= 0
                  && index < this.store_getters_tab("content").length
                  && this.store_getters_tab("content")[index].data.status.startsWith("editing")){
                  var content = this.store_getters_tab("content")[index].data.memo;
                  if(content.sentence !== content.original
                    && content.original !== null){
                    return false;
                  }
                }
              }
              return true;
            }else{
              // 選択なし
              return true;
            }
          },
          action: (emit) => {
            emit({
              command: "reset",
              param: {
                column: "memo"
              }
            });
          },
          restore_pos: "head"
        },
        split: {
          icon: "mdi-set-split",
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")){
              return false;
            }else{
              return true;
            }
          },
          action: null
        },
        insert_sentence_above: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")){
              return false;
            }else{
              return true;
            }
          },
          action: (emit) => { emit({ command: "insert_sentence_above" }) },
          restore_pos: "head"
        },
        insert_sentence_below: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")){
              return false;
            }else{
              return true;
            }
          },
          action: (emit) => { emit({ command: "insert_sentence_below" }) },
          restore_pos: "head"
        },
        duplicate_sentence: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")){
              return false;
            }else{
              return true;
            }
          },
          action: (emit) => { emit({ command: "duplicate_sentence" }) },
          restore_pos: "cur"
        },
        split_sentence: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")){
              return false;
            }else{
              return true;
            }
          },
          action: (emit) => { emit({ command: "split_sentence" }) },
          restore_pos: "none"
        },
        merge: {
          icon: "mdi-set-merge",
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length
              && (this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")
              || this.store_getters_tab("content")[indexes[0]].data.status === "deleted")){
              return false;
            }else{
              return true;
            }
          },
          action: null,
        },
        merge_sentence_above: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] > 0
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")
              && this.store_getters_tab("content")[indexes[0] - 1].data.status.startsWith("editing")){
              return false;
            }else{
              return true;
            }
          },
          action: (emit) => { emit({ command: "merge_sentence_above" }) },
          restore_pos: "head"
        },
        merge_sentence_below: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length - 1
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")
              && this.store_getters_tab("content")[indexes[0] + 1].data.status.startsWith("editing")){
              return false;
            }else{
              return true;
            }
          },
          action: (emit) => { emit({ command: "merge_sentence_below" }) },
          restore_pos: "head"
        },
        delete_sentence: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status.startsWith("editing")){
              return false;
            }else{
              return true;
            }
          },
          action: (emit) => { emit({ command: "delete_sentence" }) },
          restore_pos: "head"
        },
        undelete_sentence: {
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length === 1
              && indexes[0] >= 0
              && indexes[0] < this.store_getters_tab("content").length
              && this.store_getters_tab("content")[indexes[0]].data.status === "deleted"){
              return false;
            }else{
              return true;
            }
          },
          action: (emit) => { emit({ command: "undelete_sentence" }) },
          restore_pos: "head"
        },
        lock: {
          icon: "mdi-lock",
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length > 0){
              // 選択あり
              for(var index of indexes){
                if(index >= 0
                  && index < this.store_getters_tab("content").length
                  && this.store_getters_tab("content")[index].data.status.startsWith("editing")){
                  return false;
                }
              }
              return true;
            }else{
              // 選択なし
              return true;
            }
          },
          action: (emit) => { emit({ command: "lock" }) },
          restore_pos: "head"
        },
        unlock: {
          icon: "mdi-lock-open",
          disabled: (indexes, column) => {
            if(indexes
              && indexes !== null
              && indexes.length > 0){
              // 選択あり
              for(var index of indexes){
                if(index >= 0
                  && index < this.store_getters_tab("content").length
                  && this.store_getters_tab("content")[index].data.status === "locked"){
                  return false;
                }
              }
              return true;
            }else{
              // 選択なし
              return true;
            }
          },
          action: (emit) => { emit({ command: "unlock" }) },
          restore_pos: "head"
        },
        // display
        zoom_in: {
          icon: "mdi-magnify-plus",
          disabled: (indexes, column) => { return this.$store.getters["editor/font_size"] >= 1.5; },
          action: (emit) => { emit({ command: "zoom_in" }) },
          restore_pos: "none"
        },
        zoom_out: {
          icon: "mdi-magnify-minus",
          disabled: (indexes, column) => { return this.$store.getters["editor/font_size"] <= 0.625; },
          action: (emit) => { emit({ command: "zoom_out" }) },
          restore_pos: "none"
        },
        display_mode: {
          icon: "mdi-view-sequential",
          disabled: (indexes, column) => { return false; },
          action: null
        },
        layout_mode: {
          disabled: (indexes, column) => { return false; },
          action: (emit) => { emit({ command: "layout_mode" }) },
          restore_pos: "none"
        },
        menu_mode: {
          disabled: (indexes, column) => { return false; },
          action: (emit) => { emit({ command: "menu_mode" }) },
          restore_pos: "none"
        },
        sentence_mode: {
          disabled: (indexes, column) => {
            return this.store_getters_tab("content_mode") === "source"
              && !(this.$store.getters["editor/memo_mode"]);
          },
          action: (emit) => { emit({ command: "sentence_mode" }) },
          restore_pos: "none"
        },
        memo_mode: {
          disabled: (indexes, column) => { return false; },
          action: (emit) => { emit({ command: "memo_mode" }) },
          restore_pos: "none"
        }
      }
    };
  },
  methods: {
    store_getters_tab: function(key){
      return this.$store.getters["editor/" + this.$store.getters["editor/select_tab"] + "/" + key];
    },
    default_shortcut: function(){
      var isFirefox = (navigator.userAgent.toLowerCase().indexOf("firefox") >= 0);
      return {
        // file
        save_all: { key: "S", shift: false },
        property: { key: "", shift: false },
        close: { key: "", shift: false },
        // edit
        undo: { key: "Z", shift: false },
        redo: { key: "Z", shift: true },
        cut_text: { key: "X", shift: false, context_menu: true },
        copy_text: { key: "C", shift: false, context_menu: true },
        paste_text: { key: (isFirefox ? "" : "V"), shift: false, context_menu: true },
        select_all: { key: "A", shift: false, context_menu: true },
        search_box: { key: "F", shift: false },
        search_next: { key: "G", shift: false },
        search_prev: { key: "G", shift: true },
        replace_next: { key: "", shift: false },
        replace_prev: { key: "", shift: false },
        replace_all: { key: "", shift: false },
        // sentence
        copy_source_to_target: { key: "", shift: false, context_menu: true },
        copy_target_to_source: { key: "", shift: false, context_menu: true },
        clear_source: { key: "", shift: false, context_menu: true },
        reset_source: { key: "", shift: false, context_menu: true },
        clear_target: { key: "", shift: false, context_menu: true },
        reset_target: { key: "", shift: false, context_menu: true },
        clear_memo: { key: "", shift: false, context_menu: true },
        reset_memo: { key: "", shift: false, context_menu: true },
        insert_sentence_above: { key: "", shift: false, context_menu: true },
        insert_sentence_below: { key: "", shift: false, context_menu: true },
        duplicate_sentence: { key: "", shift: false, context_menu: true },
        split_sentence: { key: "", shift: false, context_menu: true },
        merge_sentence_above: { key: "", shift: false, context_menu: true },
        merge_sentence_below: { key: "", shift: false, context_menu: true },
        delete_sentence: { key: "", shift: false, context_menu: true },
        undelete_sentence: { key: "", shift: false, context_menu: true },
        lock: { key: "L", shift: false, context_menu: true },
        unlock: { key: "L", shift: true, context_menu: true },
        // display
        zoom_in: { key: "", shift: false },
        zoom_out: { key: "", shift: false },
        layout_mode: { key: "", shift: false },
        menu_mode: { key: "", shift: false },
        sentence_mode: { key: "", shift: false },
        memo_mode: { key: "", shift: false }
      };
    },
    unset_shortcut: function(){
      return {
        // file
        save_all: { key: "", shift: false },
        property: { key: "", shift: false },
        close: { key: "", shift: false },
        // edit
        undo: { key: "", shift: false },
        redo: { key: "", shift: false },
        cut_text: { key: "", shift: false, context_menu: true },
        copy_text: { key: "", shift: false, context_menu: true },
        paste_text: { key: "", shift: false, context_menu: true },
        select_all: { key: "", shift: false, context_menu: true },
        search_box: { key: "", shift: false },
        search_next: { key: "", shift: false },
        search_prev: { key: "", shift: false },
        replace_next: { key: "", shift: false },
        replace_prev: { key: "", shift: false },
        replace_all: { key: "", shift: false },
        // sentence
        copy_source_to_target: { key: "", shift: false, context_menu: true },
        copy_target_to_source: { key: "", shift: false, context_menu: true },
        clear_source: { key: "", shift: false, context_menu: true },
        reset_source: { key: "", shift: false, context_menu: true },
        clear_target: { key: "", shift: false, context_menu: true },
        reset_target: { key: "", shift: false, context_menu: true },
        clear_memo: { key: "", shift: false, context_menu: true },
        reset_memo: { key: "", shift: false, context_menu: true },
        insert_sentence_above: { key: "", shift: false, context_menu: true },
        insert_sentence_below: { key: "", shift: false, context_menu: true },
        duplicate_sentence: { key: "", shift: false, context_menu: true },
        split_sentence: { key: "", shift: false, context_menu: true },
        merge_sentence_above: { key: "", shift: false, context_menu: true },
        merge_sentence_below: { key: "", shift: false, context_menu: true },
        delete_sentence: { key: "", shift: false, context_menu: true },
        undelete_sentence: { key: "", shift: false, context_menu: true },
        lock: { key: "", shift: false, context_menu: true },
        unlock: { key: "", shift: false, context_menu: true },
        // display
        zoom_in: { key: "", shift: false },
        zoom_out: { key: "", shift: false },
        layout_mode: { key: "", shift: false },
        menu_mode: { key: "", shift: false },
        sentence_mode: { key: "", shift: false },
        memo_mode: { key: "", shift: false }
      };
    },
    wrap_history_action: function(action_name, history_index){
      return (emit) => {
        emit({
          command: action_name,
          param: {
            history_index: history_index
          }
        });
      };
    }
  },
  computed: {
    undo_items: function(){
      if(!this.store_getters_tab("history")){
        return [];
      }
      var items = [];
      for(var i = this.store_getters_tab("history_index"); i < this.store_getters_tab("history").length; i++){
        var history = this.store_getters_tab("history")[i];
        var name_param = {
          op: history.op,
          history_index: i,
        };
        var no = [];
        for(var change of history.changes){
          if(change.before !== null
            && change.after !== null){
            no.push(change.no);
          }
        }
        if(no.length <= 3){
          name_param.no = no.join(", ");
        }else{
          name_param.no = no.slice(0, 3).join(", ") + "...";
        }
        items.push({
          type: "item",
          name: "history",
          name_param: name_param,
          action: this.wrap_history_action("undo", i)
        });
      }
      return items;
    },
    redo_items: function(){
      var items = [];
      for(var i = this.store_getters_tab("history_index") - 1; i >= 0; i--){
        var history = this.store_getters_tab("history")[i];
        var name_param = {
          op: history.op,
          history_index: i,
        };
        var no = [];
        for(var change of history.changes){
          if(change.before !== null
            && change.after !== null){
            no.push(change.no);
          }
        }
        if(no.length <= 3){
          name_param.no = no.join(", ");
        }else{
          name_param.no = no.slice(0, 3).join(", ") + "...";
        }
        items.push({
          type: "item",
          name: "history",
          name_param: name_param,
          action: this.wrap_history_action("redo", i + 1)
        });
      }
      return items;
    },
    ctx_menu_items: function(){
      return function(param){
        var items = [];
        var index = param.index;
        var column = param.column;
        for(var item of this.menu_items){
          for(var sub_item of item.sub_items){
            if(sub_item.type !== 'divider'){
              if('sub_sub_items' in sub_item){
                for(var sub_sub_item of sub_item.sub_sub_items){
                  if((sub_sub_item.name in this.preference_shortcut
                    && ('context_menu' in this.preference_shortcut[sub_sub_item.name])
                    && !this.preference_shortcut[sub_sub_item.name].context_menu)
                    || !('context_menu' in sub_sub_item)
                    || !sub_sub_item.context_menu(index, column)){
                    continue;
                  }
                  if(sub_sub_item.type !== 'divider'){
                    items.push({
                      type: "item",
                      name: sub_sub_item.name,
                      disabled: this.menu_details[sub_sub_item.name].disabled([index], column),
                      action: this.wrap_wrap_ctx_action(
                        index,
                        column,
                        this.menu_details[sub_sub_item.name].action,
                        this.menu_details[sub_sub_item.name].restore_pos
                      )
                    });
                  }else{  // sub_sub_item.type === 'divider'
                    items.push({
                      type: "divider",
                    });
                  }
                }
              }else{  // !('sub_sub_items' in sub_item)
                if((!(sub_item.name in this.preference_shortcut)
                  || !('context_menu' in this.preference_shortcut[sub_item.name])
                  || this.preference_shortcut[sub_item.name].context_menu)
                  && ('context_menu' in sub_item)
                  && sub_item.context_menu(index, column)){
                  items.push({
                    type: "item",
                    name: sub_item.name,
                    disabled: this.menu_details[sub_item.name].disabled([index], column),
                    action: this.wrap_wrap_ctx_action(
                      index,
                      column,
                      this.menu_details[sub_item.name].action,
                      this.menu_details[sub_item.name].restore_pos
                    )
                  });
                }
              }
            }else{  // sub_item.type === 'divider'
              if(('context_menu' in sub_item)
                && sub_item.context_menu(index, column)){
                items.push({
                  type: "divider",
                });
              }
            }
          }
        }
        return items;
      }
    }
  }
}
